// ----------------------------------------------------------------------
// <copyright file='Izenda.SimpleSecurityInfo.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var Panel = require('share/components/controls/Izenda.Panel');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var EventUtils = require('EventUtils');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
  var actions = require('modules/Account/Izenda.SimpleSecurityInfoActions');
  const { isNil } = require('lodash/fp');

  var Header = function header(props) {
    var localization = props.localization;

    return (
      <div>
        <div>{localization.getText('ACOUNT_MESSAGE_PROVIDE_NEW_PASSWORD_SECURITY_TO_FURTHER_PROCEED')}</div>
        {!isNil(props.message) ? (
          <div className="izenda-Account-errorMessage izenda-Account-errorMessage-info u_textLeft">{props.message}</div>
        ) : null}
      </div>
    );
  };

  var Footer = function footer(props) {
    var localization = props.localization;

    return (
      <div className="u_textRight">
        <button className="btn btn-primary izenda-Account-btn" onClick={props.onClickBack}>
          {localization.getText('ACOUNT_LABEL_BACK')}
        </button>
        <button className="btn btn-primary izenda-Account-btn" onClick={props.onClickNext}>
          {localization.getText('ACOUNT_LABEL_NEXT')}
        </button>
      </div>
    );
  };

  var SimpleSecurityInfo = React.createClass({
    /**
     * Render security questions
     */
    renderSecurityQuestions: function() {
      var props = this.props;
      var model = props.store.model;
      var questions = model.userSecurityQuestions;
      if (!questions.length) return null;
      return questions.map(
        function(question) {
          return (
            <GridLayout.Row key={question.question}>
              <GridLayout>
                <GridLayout.Row>
                  <GridLayout.Col cols="11" offset="1" className="izenda-SecurityInfo-Question u_textLeft">
                    <label className="validation required">{question.question}</label>
                  </GridLayout.Col>
                </GridLayout.Row>
                <GridLayout.Row>
                  <GridLayout.Col cols="11" offset="1" className="izenda-SecurityInfo-Question">
                    {renderAnswer(question)}
                  </GridLayout.Col>
                </GridLayout.Row>
              </GridLayout>
            </GridLayout.Row>
          );
        }.bind(this)
      );

      /**
       * Render answer.
       */
      function renderAnswer(question) {
        return (
          <ValidateInput
            type="text"
            className="form-control"
            value={question.answer}
            onChange={EventUtils.notifyChange(updateValue, EventUtils.INPUT)}
            field={'answer-' + question.securityQuestionId}
            validations={AccountConstants.CONSTRAINTS.answer}
          />
        );

        /**
         * Handle change answer.
         */
        function updateValue(data) {
          props.onChangeAnswer(question, data);
        }
      }
    },

    /**
     * Render body.
     */
    renderBody: function() {
      var props = this.props;
      var model = props.store.model;
      return <GridLayout>{this.renderSecurityQuestions()}</GridLayout>;
    },

    render: function() {
      var props = this.props;
      var model = this.props.store.model;
      if (!model.isCurrentStep(AccountConstants.STEP_KEYS.QuestionInfo)) return null;

      var header = {
        component: Header,
        message: model.message,
        localization: props.localization
      };

      var footer = {
        component: Footer,
        onClickBack: props.onClickBack,
        onClickNext: props.onClickNext,
        store: props.store,
        localization: props.localization
      };

      return (
        <Panel className="izenda-Account-Container" header={header} footer={footer}>
          {this.renderBody()}
        </Panel>
      );
    }
  });

  module.exports = connect(actions)(SimpleSecurityInfo);
})();



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.SimpleSecurityInfo.jsx